import { Avatar, Button, Typography } from '@mui/material';
import { PlusBtn } from 'Images';
import { FC } from 'react';

interface IDocumentTypeButton {
  label: string;
  onClick: () => void;
  isSelected?: boolean;
}

export const DocumentTypeButton: FC<IDocumentTypeButton> = ({
  label,
  onClick,
  isSelected = false,
}) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        width: 'fit-content',
        height: '40px',
        borderRadius: '48px',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        backgroundColor: '#F6F8FE',
        p: '8px 16px',
        display: 'flex',
        gap: '6px',
      }}
      aria-pressed={isSelected}
    >
      <Avatar
        alt=''
        src={PlusBtn}
        sx={{
          width: '14px',
          height: '14px',
        }}
      />
      <Typography
        variant='body6'
        sx={{
          color: '#1552E8',
        }}
      >
        {label}
      </Typography>
    </Button>
  );
};
